import { render, staticRenderFns } from "./NewList2.vue?vue&type=template&id=60edd360&scoped=true&"
import script from "./NewList2.vue?vue&type=script&lang=js&"
export * from "./NewList2.vue?vue&type=script&lang=js&"
import style0 from "./NewList2.vue?vue&type=style&index=0&id=60edd360&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60edd360",
  null
  
)

export default component.exports